/*!
 * share.js — bandeja nativa e copiar link da régua de compartilhamento.
 *
 * Só isto. WhatsApp, Pinterest e Facebook são `<a href>` no Liquid e não
 * precisam de JS nenhum — se este arquivo não carregar, a régua continua
 * funcionando com quatro dos cinco botões.
 *
 * Delegação no `document`: a régua aparece duas vezes na página do artigo
 * (topo e fim do texto) e pode ser reinserida por Section Rendering. Listener
 * preso ao nó morreria no primeiro re-render — o mesmo bug histórico que a
 * régua de upsell já pagou.
 */
(function () {
  "use strict";

  /* A bandeja nativa não existe no desktop. O botão nasce com `hidden` no
     Liquid e só é revelado quando a API responde — nunca pinta um botão que
     abriria nada. `navigator.share` sem `canShare` acontece em navegador
     antigo; aceitamos os dois. */
  function revelaNativo() {
    if (!navigator.share) return;
    document.querySelectorAll("[data-share-native]").forEach(function (b) {
      b.removeAttribute("hidden");
    });
  }

  function raiz(el) {
    return el && el.closest ? el.closest("[data-share]") : null;
  }

  function avisa(box, texto) {
    if (!box) return;
    var p = box.querySelector("[data-share-done]");
    if (!p) return;
    p.textContent = texto;
    p.removeAttribute("hidden");
    clearTimeout(p._t);
    p._t = setTimeout(function () { p.setAttribute("hidden", ""); }, 2600);
  }

  /* Fallback de cópia para contexto sem Clipboard API — que inclui HTTP e
     alguns webviews de app. `execCommand` está deprecado e é exatamente por
     isso que fica só no fallback: quando ele é a única coisa que existe, ainda
     é melhor que um botão que não faz nada. */
  function copiaLegado(txt) {
    try {
      var ta = document.createElement("textarea");
      ta.value = txt;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.top = "-1000px";
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch (e) {
      return false;
    }
  }

  document.addEventListener("click", function (e) {
    var alvo = e.target;
    if (!alvo || !alvo.closest) return;

    var nativo = alvo.closest("[data-share-native]");
    if (nativo) {
      e.preventDefault();
      var box = raiz(nativo);
      if (!box || !navigator.share) return;
      navigator
        .share({
          title: box.getAttribute("data-share-title") || document.title,
          url: box.getAttribute("data-share-url") || location.href,
        })
        .catch(function () {
          /* AbortError é a cliente fechando a bandeja. Não é erro e não vira
             aviso na tela — só silêncio. */
        });
      return;
    }

    var copiar = alvo.closest("[data-share-copy]");
    if (copiar) {
      e.preventDefault();
      var caixa = raiz(copiar);
      var url = caixa ? caixa.getAttribute("data-share-url") : location.href;
      if (!url) url = location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(
          function () { avisa(caixa, "Link copiado."); },
          function () {
            avisa(caixa, copiaLegado(url) ? "Link copiado." : "Não foi possível copiar.");
          }
        );
      } else {
        avisa(caixa, copiaLegado(url) ? "Link copiado." : "Não foi possível copiar.");
      }
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", revelaNativo);
  } else {
    revelaNativo();
  }
})();
